import React from "react";
import ServicePeriod from "./ServicePeriod";
import ServiceSpeed from "./ServiceSpeed";

export default function ServiceCategoryCard({ category, onProductClick }) {
	return (
		<div
			className="bg-white shadow-sm p-3 p-md-4 mb-0"
			style={{ borderRadius: 8 }}
		>
			<div className="text-center border-bottom pb-2 mb-2">
				<ServiceSpeed speed={category.Category} />
			</div>
			<div className="d-flex flex-column" style={{ gap: "16px" }}>
				{category.Products.map((product) => (
					<ServicePeriod
						key={product.Id}
						product={product}
						onClick={() => onProductClick(category.Category, product)}
					/>
				))}
			</div>
		</div>
	);
}
